import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {agoraRouting} from './agora.routing';

import {CommonModule} from '@angular/common';

import {SharedModule} from '../shared/shared.module';

import {DashboardComponent} from './components/dashboard/dashboard.component';
import {ProductDataDashboardComponent} from './components/product-data/dashboard/product-data-dashboard.component';
import {AccountDataDashboardComponent} from './components/account-data/dashboard/account-data-dashboard.component';
// Catalogs
import {CatalogsComponent} from './components/product-data/catalogs/catalogs.component';
import {CatalogService} from './components/product-data/catalogs/catalog.service';

import {CatalogAddComponent} from './components/product-data/catalogs/add/catalog-add.component';
import {CatalogDetailsComponent} from './components/product-data/catalogs/details/catalog-details.component';
import {CatalogEditComponent} from './components/product-data/catalogs/edit/catalog-edit.component';
// Categories
import {CategoriesComponent} from './components/product-data/categories/categories.component';
import {CategoryService} from './components/product-data/categories/category.service';

import {CategoryAddComponent} from './components/product-data/categories/add/category-add.component';
import {CategoryDetailsComponent} from './components/product-data/categories/details/category-details.component';
import {CategoryEditComponent} from './components/product-data/categories/edit/category-edit.component';
// Products
import {ProductsComponent} from './components/product-data/products/products.component';
import {ProductsService} from './components/product-data/products/products.service';

import {ProductAddComponent} from './components/product-data/products/add/product-add.component';
import {ProductDetailsComponent} from './components/product-data/products/details/product-details.component';
import {ProductDetailsVariantsComponent} from './components/product-data/products/details/product-details-variants/product-details-variants.component';
import {ProductEditComponent} from './components/product-data/products/edit/product-edit.component';
import {ProductBulkEditComponent} from './components/product-data/products/bulk-edit/product-bulk-edit.component';
// Product Groups
import {ProductGroupsComponent} from './components/product-data/product-groups/product-groups.component';
import {ProductGroupService} from './components/product-data/product-groups/product-group.service';
import {ProductFilterListComponent} from './components/product-filter-list/product-filter-list.component';

import {ProductGroupAddComponent} from './components/product-data/product-groups/add/product-group-add.component';
import {ProductGroupDetailsComponent} from './components/product-data/product-groups/details/product-group-details.component';
import {ProductGroupEditComponent} from './components/product-data/product-groups/edit/product-group-edit.component';
// Configurations
import {ConfigurationService} from './components/configurations/configuration.service';
import {ConfigurationsComponent} from './components/configurations/configurations.component';

import {ConfigurationDetailsComponent} from './components/configurations/details/configuration-details.component';
import {ConfigurationAddComponent} from './components/configurations/add/configuration-add.component';
import {ConfigurationEditComponent} from './components/configurations/edit/configuration-edit.component';
// Accounts
import {AccountsComponent} from './components/account-data/accounts/accounts.component';
import {AccountService} from './components/account-data/accounts/account.service';
import {AccountDetailsComponent} from './components/account-data/accounts/details/account-details.component';
import {AccountEditComponent} from './components/account-data/accounts/edit/account-edit.component';

import {UpdatePrintLogoComponent} from './components/account-data/accounts/edit/update-print-logo/update-print-logo.component';
import {UpdateBrandedLogoComponent} from './components/account-data/accounts/edit/update-branded-logo/update-branded-logo.component';
// Banking Data
import {BankingDataComponent} from './components/account-data/banking-data/banking-data.component';
import {BankingDataService} from './components/account-data/banking-data/banking-data.service';

import {BankingDataAddComponent} from './components/account-data/banking-data/add/banking-data-add.component';
import {BankingDataDetailsComponent} from './components/account-data/banking-data/details/banking-data-details.component';
import {BankingDataEditComponent} from './components/account-data/banking-data/edit/banking-data-edit.component';
// Taxation Data
import {TaxationDataComponent} from './components/account-data/taxation-data/taxation-data.component';
import {TaxationDataService} from './components/account-data/taxation-data/taxation-data.service';

import {TaxationDataAddComponent} from './components/account-data/taxation-data/add/taxation-data-add.component';
import {TaxationDataDetailsComponent} from './components/account-data/taxation-data/details/taxation-data-details.component';
import {TaxationDataEditComponent} from './components/account-data/taxation-data/edit/taxation-data-edit.component';
// Employees
import {EmployeesComponent} from './components/account-data/employees/employees.component';
import {EmployeeService} from './components/account-data/employees/employee.service';

import {EmployeeAddComponent} from './components/account-data/employees/add/employee-add.component';
import {EmployeeDetailsComponent} from './components/account-data/employees/details/employee-details.component';
import {EmployeeEditComponent} from './components/account-data/employees/edit/employee-edit.component';
// Communication
import {CommunicationComponent} from './components/account-data/communication/communication.component';
import {CommunicationService} from './components/account-data/communication/communication.service';

import {CommunicationAddComponent} from './components/account-data/communication/add/communication-add.component';
import {CommunicationDetailsComponent} from './components/account-data/communication/details/communication-details.component';
import {CommunicationEditComponent} from './components/account-data/communication/edit/communication-edit.component';
import {PhoneNumbersComponent} from './components/account-data/communication/phone-numbers/phone-numbers.component';
import {EmployeeFormComponent} from './components/account-data/employees/form/employee-form.component';
import {UpdatePricelistComponent} from './components/account-data/accounts/edit/update-pricelist/update-pricelist.component';
import {UpdateSmtpComponent} from 'app/agora/components/account-data/accounts/edit/update-smtp/update-smtp.component';

import {ProductEditBaseComponent} from './components/product-data/products/edit/base/product-edit-base.component';
import {ProductEditDetailsComponent} from './components/product-data/products/edit/details/product-edit-details.component';
import {ProductEditCreditsComponent} from './components/product-data/products/edit/credits/product-edit-credits.component';
import {ProductEditInstructionsComponent} from './components/product-data/products/edit/instructions/product-edit-instructions.component';
import {ProductEditPricingComponent} from './components/product-data/products/edit/pricing/product-edit-pricing.component';
import {ProductEditRenderComponent} from './components/product-data/products/edit/render/product-edit-render.component';
import {ProductEditSalesInfoComponent} from './components/product-data/products/edit/sales-info/product-edit-sales-info.component';
import {ProductEditCourseInfoComponent} from './components/product-data/products/edit/course-info/product-edit-course-info.component';
import {ProductEditExamInfoComponent} from './components/product-data/products/edit/exam-info/product-edit-exam-info.component';
// Product Variants
import {ProductVariantsComponent} from './components/product-data/product-variants/product-variants.component';
import {ProductVariantService} from './components/product-data/product-variants/product-variant.service';
import {ProductVariantAddComponent} from './components/product-data/product-variants/add/product-variant-add.component';
import {ProductVariantDetailsComponent} from './components/product-data/product-variants/details/product-variant-details.component';
import {ProductVariantEditComponent} from './components/product-data/product-variants/edit/product-variant-edit.component';
import {ProductVariantEditBaseComponent} from './components/product-data/product-variants/common/base/product-variant-edit-base.component';
import {ProductVariantEditDeliveryComponent} from './components/product-data/product-variants/common/delivery/product-variant-edit-delivery.component';
import {ProductVariantEditRendersComponent} from './components/product-data/product-variants/edit/renders/product-variant-edit-renders.component';
import {ProductVariantsBulkEditComponent} from './components/product-data/product-variants/product-variants-bulk-edit/product-variants-bulk-edit.component';
// Product Segments
import {ProductSegmentsComponent} from './components/product-data/product-segments/product-segments.component';
import {ProductSegmentAddComponent} from './components/product-data/product-segments/add/product-segment-add.component';
import {ProductSegmentDetailsComponent} from './components/product-data/product-segments/details/product-segment-details.component';
import {ProductSegmentEditComponent} from './components/product-data/product-segments/edit/product-segment-edit.component';
import {ProductSegmentService} from './components/product-data/product-segments/product-segment.service'


import {CreditComponent} from './components/account-data/credit/credit.component';
import {CreditDetailsComponent} from './components/account-data/credit/details/credit-details.component';
import {CreditService} from './components/account-data/credit/credit.service';
import {CreditCommonService} from './components/account-data/common/services/credit-common.service';
import {CreateCreditApplicationComponent} from './components/account-data/accounts/details/create-credit-application/create-credit-application.component';
import {CreditEditComponent} from './components/account-data/credit/edit/credit-edit.component';
import {CreditApplicationFormComponent} from './components/account-data/common/credit-application-form/credit-application-form.component';
import {ApproveComponent} from './components/account-data/credit/approve/approve.component';
import {RejectComponent} from './components/account-data/credit/reject/reject.component';
import {RemoveCreditApplicationComponent} from './components/account-data/accounts/details/remove-credit-application/remove-credit-application.component';
import {UpdateFinanceComponent} from './components/account-data/accounts/edit/update-finance/update-finance.component';
//Topics
import {TopicsComponent} from './components/product-data/topics/topics.component';
import {TreeModule} from 'angular-tree-component';
import {TopicsService} from './components/product-data/topics/topics.service';
import {TopicSubtopicAddComponent} from './components/product-data/topics/add/topic-subtopic-add.component';
import {UpdateSellerAccountComponent} from './components/account-data/accounts/edit/update-seller-account/update-seller-account.component';
//Brands
import {BrandsComponent} from './components/product-data/brands/brands.component';
import {BrandAddComponent} from './components/product-data/brands/add/add.component';
import {BrandService} from 'app/agora/components/product-data/brands/brand.service';
import {BrandEditComponent} from './components/product-data/brands/edit/edit.component';
import {BrandDetailsComponent} from './components/product-data/brands/details/details.component';
import {SurchargesService} from './components/product-data/surcharges/surcharges.service';
import {SurchargesComponent} from './components/product-data/surcharges/surcharges.component';
import {SurchargesAddComponent} from './components/product-data/surcharges/add/surcharges.add.component';
import {SurchargesEditComponent} from './components/product-data/surcharges/edit/surcharges.edit.component';
import {SurchargesDetailsComponent} from './components/product-data/surcharges/details/surcharges.details.component';
import {PricingListComponent} from './components/pricing-data/pricing-list/pricing-list.component';
import {PricingListDetailsComponent} from './components/pricing-data/pricing-list/pricing-list-details/pricing-list-details.component';
import {PlatformPriceListService} from './components/pricing-data/pricing-list/platform-price-list.service';
import {PricingDashboardComponent} from './components/pricing-data/dashboard/pricing-dashboard.component';
import {AccountConfigurationsComponent} from './components/account-configurations/account-configurations.component';
import {AccountConfigurationsAddComponent} from './components/account-configurations/add/account-configurations-add.component';
import {AccountConfigurationsDetailsComponent} from './components/account-configurations/details/account-configurations-details.component';
import {AccountConfigurationService} from './components/account-configurations/account-configuration.service';
import {AccountConfigurationsEditComponent} from './components/account-configurations/edit/account-configurations-edit.component';
import { CustomTopicsComponent } from './components/product-data/custom-topics/custom-topics.component';
import { CustomTopicsService } from './components/product-data/custom-topics/custom-topics.service';
import { CustomTopicSubtopicAddComponent } from './components/product-data/custom-topics/custom-topic-subtopic-add/custom-topic-subtopic-add.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { SvgUploaderModalComponent } from './components/product-data/topics/svg-uploader-modal/svg-uploader-modal.component';

@NgModule({
    imports: [
        FormsModule,
        agoraRouting,
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        TreeModule,
        Ng2SearchPipeModule
    ],
    declarations: [
        DashboardComponent,
        ProductDataDashboardComponent,
        AccountDataDashboardComponent,

        CatalogsComponent,
        CatalogAddComponent,
        CatalogDetailsComponent,
        CatalogEditComponent,

        ProductsComponent,
        ProductAddComponent,
        ProductDetailsComponent,
        ProductEditComponent,
        ProductBulkEditComponent,

        ProductVariantsComponent,
        ProductVariantAddComponent,
        ProductVariantDetailsComponent,
        ProductVariantEditComponent,
        ProductFilterListComponent,
        ConfigurationsComponent,
        ConfigurationDetailsComponent,
        ConfigurationAddComponent,
        ConfigurationEditComponent,

        CategoriesComponent,
        CategoryAddComponent,
        CategoryDetailsComponent,
        CategoryEditComponent,

        AccountsComponent,
        AccountDetailsComponent,
        AccountEditComponent,

        UpdatePrintLogoComponent,
        UpdateBrandedLogoComponent,

        BankingDataComponent,
        BankingDataAddComponent,
        BankingDataDetailsComponent,
        BankingDataEditComponent,

        TaxationDataComponent,
        TaxationDataAddComponent,
        TaxationDataDetailsComponent,
        TaxationDataEditComponent,

        EmployeesComponent,
        EmployeeAddComponent,
        EmployeeDetailsComponent,
        EmployeeEditComponent,

        CommunicationComponent,
        CommunicationAddComponent,
        CommunicationDetailsComponent,
        CommunicationEditComponent,

        ProductGroupsComponent,
        ProductGroupAddComponent,
        ProductGroupDetailsComponent,
        ProductGroupEditComponent,
        PhoneNumbersComponent,
        EmployeeFormComponent,
        UpdatePricelistComponent,
        UpdateSmtpComponent,
        ProductEditBaseComponent,
        ProductEditDetailsComponent,
        ProductEditCreditsComponent,
        ProductEditInstructionsComponent,
        ProductEditPricingComponent,
        ProductEditRenderComponent,
        ProductEditSalesInfoComponent,
        ProductEditCourseInfoComponent,
        ProductEditExamInfoComponent,

        ProductVariantEditBaseComponent,
        ProductVariantEditDeliveryComponent,
        ProductVariantEditRendersComponent,

        CreditComponent,
        CreditDetailsComponent,
        CreateCreditApplicationComponent,
        CreditEditComponent,
        CreditApplicationFormComponent,
        ApproveComponent,
        RejectComponent,
        ProductSegmentsComponent,
        ProductSegmentAddComponent,
        ProductSegmentDetailsComponent,
        ProductSegmentEditComponent,
        ProductDetailsVariantsComponent,
        RemoveCreditApplicationComponent,
        UpdateFinanceComponent,
        ProductVariantsBulkEditComponent,
        TopicsComponent,
        TopicSubtopicAddComponent,
        UpdateSellerAccountComponent,

        BrandsComponent,
        BrandAddComponent,
        BrandEditComponent,
        BrandDetailsComponent,

        SurchargesComponent,
        SurchargesAddComponent,
        SurchargesEditComponent,
        SurchargesDetailsComponent,

        PricingDashboardComponent,
        PricingListComponent,
        PricingListDetailsComponent,

        AccountConfigurationsComponent,
        AccountConfigurationsAddComponent,
        AccountConfigurationsDetailsComponent,
        AccountConfigurationsEditComponent,
        CustomTopicsComponent,
        CustomTopicSubtopicAddComponent,
        SvgUploaderModalComponent

    ],
    providers: [
        ProductsService,
        AccountService,
        CatalogService,
        CategoryService,
        ProductVariantService,
        ProductGroupService,
        BankingDataService,
        TaxationDataService,
        EmployeeService,
        CommunicationService,
        ConfigurationService,
        CreditService,
        CreditCommonService,
        ProductSegmentService,
        TopicsService,
        BrandService,
        SurchargesService,
        PlatformPriceListService,
        AccountConfigurationService,
        CustomTopicsService
    ],
    entryComponents: [
        ApproveComponent,
        RejectComponent,
        RemoveCreditApplicationComponent,
        TopicSubtopicAddComponent,
        CustomTopicSubtopicAddComponent,
        SvgUploaderModalComponent
    ]

})

export class AgoraModule {}



// WEBPACK FOOTER //
// ./src/app/agora/agora.module.ts